<ng-container *ngFor="let item of items; let i = index">
  <li [@loadedFadeAnimation]="'visible'" *ngIf="(!item.SubItems || item.SubItems.length == 0) && (!item.Class.includes(excludedLinkClass) || (excludedLinkClass == '' && excludedLinkClass != item.Class))" class="nav-item {{item.Class}}" id="{{item.Id}}">
    <a [ngClass]="{'active': isActiveLink(item.Url)}" [routerLink]="item.Url" class="nav-link" class="nav-link">
      {{item.Title}}
    </a>
  </li>
  <li [@loadedFadeAnimation]="'visible'" *ngIf="(item.SubItems && item.SubItems.length > 0) && (!item.Class.includes(excludedLinkClass) || (excludedLinkClass == '' && excludedLinkClass != item.Class))" class="nav-item dropdown hover {{item.Class}}" id="{{item.Id}}">
    <a [ngClass]="{'active': isActiveLink(getSubItemsUrls(item.SubItems))}" class="nav-link dropdown-toggle" id="menu{{item.Id}}" role="button" data-bs-toggle="dropdown" aria-expanded="false">
      {{item.Title}}
    </a>
    <ul class="submenu dropdown-menu animate fade-down" [attr.aria-labelledby]="'menu' + item.Id" id="menu{{item.Id}}" [attr.data-bs-parent]="'#' + idparent" app-menu [items]="item.SubItems" [idparent]="'menu' + item.Id">
    </ul>
  </li>
</ng-container>
